import React from 'react';
import { AvatarGroup as MuiAvatarGroup } from '@mui/material';
import { AvatarGroupProps } from '@mui/material';
type AvatarGroupPropsExtended = AvatarGroupProps;

function AvatarGroup({ max, ...props }: AvatarGroupPropsExtended) {
  return (
    <MuiAvatarGroup
      max={max}
      {...props}
      sx={{
        '& .MuiAvatarGroup-avatar': {
          zIndex: max ? max : 'auto',
        },
      }}
    >
      {props.children}
    </MuiAvatarGroup>
  );
}

export default AvatarGroup;
